<!--distributing-->
<template>
  <div class="distributing kanban">
    <div class="con">
      <div class="title-top">
        <div class="ti-time">
          <span>{{YMRtime}}</span>
          <span style="margin-left:15px">{{SFMtime}}</span>
        </div>
        <div class="ti-topimg">
          <img src="../../assets/puKanBan/bigtitle.png">
        </div>
        <div class="ti-fangda">
          <img src="../../assets/puKanBan/suoxiao.png" v-if="fullscreen" @click="handleFullScreen">
          <img src="../../assets/puKanBan/fangda.png" v-else @click="handleFullScreen">
        </div>
      </div>
      <div class="con-body">
        <div class="body-left">
          <div class="roominformation smbg">
            <div class="small-title">
              <span>机房设备信息</span>
              <img src="../../assets/puKanBan/mutibg.png" alt="" class="smbgimg">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowleft">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowright">
            </div>
            <div class="smcon">
              <div class="jifang-item total1">
                <img src="../../assets/puKanBan/jifang.png" alt="">
                <div class="numall">1</div>
                <div class="text">机房总数</div>
              </div>
              <div class="jifang-item total2">
                <img src="../../assets/puKanBan/devAllnum.png" alt="">
                <div class="numall">{{jifangList.all}}</div>
                <div class="text">设备总数</div>
              </div>
              <div class="jifang-item total3">
                <img src="../../assets/puKanBan/baojing.png" alt="">
                <div class="numall">{{jifangList.offline}}</div>
                <div class="text">异常设备</div>
              </div>
            </div>
          </div>
          <div class="temperature smbg">
            <div class="small-title">
              <span>温湿度监测</span>
              <img src="../../assets/puKanBan/mutibg.png" alt="" class="smbgimg">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowleft">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowright">
            </div>
            <div class="tempercon">
              <div class="tempercon-top">
                <div>设备名称</div>
                <div>温度(°C)</div>
                <div>湿度(%)</div>
                <div>状态</div>
              </div>
              <div class="templine"></div>
              <div class="tempercon-item">
                <div class="itname">温湿度1</div>
                <div class="wendu">{{wenshiList['温湿度1']['0']}}</div>
                <div class="shidu">{{wenshiList['温湿度1']['1']}}</div>
                <div :class="['state',{'greenjing':wenshiList['温湿度1']['2'] == 1}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
              </div>
              <div class="tempercon-item texu">
                <div class="itname">温湿度2</div>
                <div class="wendu">{{wenshiList['温湿度2']['0']}}</div>
                <div class="shidu">{{wenshiList['温湿度2']['1']}}</div>
                <div :class="['state',{'greenjing':wenshiList['温湿度2']['2'] == 1}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
              </div>
              <div class="tempercon-item">
                <div class="itname">温湿度3</div>
                <div class="wendu">{{wenshiList['温湿度3']['0']}}</div>
                <div class="shidu">{{wenshiList['温湿度3']['1']}}</div>
                <div :class="['state',{'greenjing':wenshiList['温湿度3']['2'] == 1}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="infrared smbg">
            <div class="small-title">
              <span>红外双鉴监测</span>
              <img src="../../assets/puKanBan/mutibg.png" alt="" class="smbgimg">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowleft">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowright">
            </div>
            <div class="infrared-con">
              <div class="tempercon-top">
                <div>设备名称</div>
                <div>电池报警</div>
                <div>开盖状态</div>
                <div>状态</div>
              </div>
              <div class="templine"></div>
              <div class="tempercon-item">
                <div class="itname">红外#1</div>
                <div :class="['state',{'greenjing':hongwaiList['0'] == 0}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
                <div :class="['state',{'greenjing':hongwaiList['1'] == 0}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
                <div :class="['state',{'greenjing':hongwaiList['2'] == 0}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
              </div>



            </div>
          </div>
          <div class="accesscontrol smbg">
            <div class="small-title">
              <span>门禁监测</span>
              <img src="../../assets/puKanBan/mutibg.png" alt="" class="smbgimg">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowleft">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowright">
            </div>
            <div class="accesscontrol-con">
              <div class="tempercon-top">
                <div>设备名称</div>
                <div>电池报警</div>
                <div>开盖状态</div>
                <div>状态</div>
              </div>
              <div class="templine"></div>
              <div class="tempercon-item">
                <div class="itname">门禁#1</div>
                <div :class="['state',{'greenjing':menjinList['0'] == 0}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
                <div :class="['state',{'greenjing':menjinList['1'] == 0}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
                <div :class="['state',{'greenjing':menjinList['2'] == 0}]">
                  <div class="bigbox">
                    <div class="box"></div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
        <div class="body-milll">
          <div class="item1">
            <img src="../../assets/puKanBan/mill1.png" alt="">
            <div class="mytext">
              <div class="tetx-item"><span>温度1</span> <span class="num1">{{wenshiList['温湿度1']['0']}}°C</span> </div>
              <div class="tetx-item"><span>湿度1</span> <span class="num1">{{wenshiList['温湿度1']['1']}}%</span></div>
            </div>
          </div>
          <div class="item2">
            <img src="../../assets/puKanBan/mill2.png" alt="">
            <div class="mytext">
              <div class="tetx-item"><span>温度2</span> <span class="num1">{{wenshiList['温湿度2']['0']}}°C</span> </div>
              <div class="tetx-item"><span>湿度2</span> <span class="num1">{{wenshiList['温湿度2']['1']}}%</span></div>
            </div>
          </div>


          <div class="item3">
            <img src="../../assets/puKanBan/mill3.png" alt="">
            <div class="mytext">
              <div class="tetx-item"><span>温度3</span> <span class="num1">{{wenshiList['温湿度3']['0']}}°C</span> </div>
              <div class="tetx-item"><span>湿度3</span> <span class="num1">{{wenshiList['温湿度3']['1']}}%</span></div>
            </div>
          </div>
          <div class="item4">
            <img src="../../assets/puKanBan/mill1.png" alt="">
            <div class="mytext">
              <div class="tetx-item"><span>状态</span> <span class="num2" v-if="shuijinList['0'] == 0">正常</span> <span
                  class="num3" v-if="shuijinList['0'] == 1">异常</span></div>
            </div>
          </div>

          <div class="item5">
            <img src="../../assets/puKanBan/mill2.png" alt="">
            <div class="mytext">
              <div class="tetx-item"><span>状态</span> <span class="num2" v-if="shuijinList['1'] == 0">正常</span> <span
                  class="num3" v-if="shuijinList['1'] == 1">异常</span> </div>
            </div>
          </div>
        </div>
        <div class="body-right">
          <div class="eventtype smbg">
            <div class="small-title">
              <span>事件类型分布统计</span>
              <img src="../../assets/puKanBan/mutibg.png" alt="" class="smbgimg">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowleft">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowright">
            </div>
            <div class="eventtype-con">
              <div class="type-item">
                <div id="main" style="width: 100%;height:100%;"></div>
                <div class="allnum">
                  <span>{{xiaoxiNum + yujingNum + gaojingNum}}</span>
                  <div>总事件数</div>
                </div>
              </div>
              <div class="type-items">
                <div class="juti">
                  <div class="titi">
                    <div class="juti-item">
                      <div class="left">
                        <div class="leftcolor colorxiaoxi"></div>
                        <div class="leftname">消息</div>
                      </div>
                      <div class="rightnum">{{xiaoxiNum}}</div>
                    </div>
                    <div class="juti-item active">
                      <div class="left">
                        <div class="leftcolor coloryujing"></div>
                        <div class="leftname">预警</div>
                      </div>
                      <div class="rightnum">{{yujingNum}}</div>
                    </div>
                    <div class="juti-item">
                      <div class="left">
                        <div class="leftcolor colorgaojing"></div>
                        <div class="leftname">报警</div>
                      </div>
                      <div class="rightnum">{{gaojingNum}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="eventlist smbg">
            <div class="small-title">
              <span>事件列表</span>
              <img src="../../assets/puKanBan/mutibg.png" alt="" class="smbgimg">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowleft">
              <img src="../../assets/puKanBan/jiantou.png" alt="" class="rowright">
            </div>
            <div class="eventlist-con">
              <el-scrollbar style="height:calc(100% - 10px);width: 100%;">
                {{eventList}}
                <div class="list-item" v-for="item in eventList" :key="item.id">
                  <div class="lefttype xiaoxitype" v-if="item.eventlevel == 0 || item.eventlevel == 3">消息</div>
                  <div class="lefttype yujingtype" v-if="item.eventlevel == 1">预警</div>
                  <div class="lefttype jingtype" v-if="item.eventlevel == 2">报警</div>
                  <div class="milltext">{{item.description}}</div>
                  <div class="righttimer">{{item.time | date_format}}</div>
                </div>

              </el-scrollbar>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
  import { findDeviceRunningStatus, findHumitureDeviceData, findInfraredDeviceData, findAccessDeviceData, findWaterLoggingData } from "../../api/reading";
  export default {


    data() {
      return {
        fullscreen: false,
        option: {

          tooltip: {
            trigger: 'item'
          },

          series: [
            {
              name: '',
              type: 'pie',
              radius: ['75%', '90%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              detail: {
                formatter: '{value}'
              },

              data: [
                { value: 0, name: '消息', itemStyle: { color: '#2ce6ff' } },
                { value: 0, name: '预警', itemStyle: { color: '#ff912c' } },
                { value: 0, name: '报警', itemStyle: { color: '#e76238' } },
              ]
            }
          ]
        },
        jifangList: { "all": 29, "online": 22, "offline": 7 },//机房数据
        wenshiList: {//温湿度数据
          '温湿度1': { 0: 24, 1: 45, 2: 1 },
          '温湿度2': { 0: 23, 1: 44, 2: 1 },
          '温湿度3': { 0: 23, 1: 47, 2: 1 }
        },
        hongwaiList: { //红外数据
          0: 0,
          1: 0,
          2: 0,
        },
        menjinList: {//门禁数据
          0: 1,
          1: 0,
          2: 0,
        },
        shuijinList: {//水浸数据
          0: 0,
          1: 0,
        },
        eventList: [],//事件
        xiaoxiNum: 0,//消息
        yujingNum: 0,//预警
        gaojingNum: 0,//告警
        listDataIn: null,
        timerIn: null,
        YMRtime: "",
        SFMtime: "",
      }
    },
    mounted() {
      this.init()
      this.getList()
      var that_ = this


      var now = new Date();

      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      var hours = String(now.getHours()).padStart(2, '0');
      var minutes = String(now.getMinutes()).padStart(2, '0');
      var seconds = String(now.getSeconds()).padStart(2, '0');

      this.YMRtime = `${year}-${month}-${day}`
      this.SFMtime = `${hours}:${minutes}:${seconds}`
      this.timerIn = setInterval(() => {
        var now = new Date();
        var year = now.getFullYear();
        var month = String(now.getMonth() + 1).padStart(2, '0');
        var day = String(now.getDate()).padStart(2, '0');
        var hours = String(now.getHours()).padStart(2, '0');
        var minutes = String(now.getMinutes()).padStart(2, '0');
        var seconds = String(now.getSeconds()).padStart(2, '0');

        that_.YMRtime = `${year}-${month}-${day}`
        that_.SFMtime = `${hours}:${minutes}:${seconds}`
      }, 1000)
    },
    beforeDestroy() {
      // 在组件销毁之后取消定时器 
      clearInterval(this.timerIn);
    },
    computed: {

      nowUnit() {
        return this.$store.unitStore.getters.getNowUnit
      },

    },
    methods: {
      // 全屏事件
      handleFullScreen() {
        // 此处可根据获取节点进行区域全屏事件
        let element = document.getElementsByClassName('kanban')[0];
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;

      },

      //初始化图表
      init() {
        var myChart = echarts.init(document.getElementById('main'));
        myChart.setOption(this.option);
        window.onresize = function () {
          myChart.resize();
        };
      },
      //获取总数据
      getList() {
        //事件
        var respon = {
          "total": 25,
          "data": [
            {
              "no": 7245,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713749947000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7244,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713407079000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7242,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713406954000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7241,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713405114000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7239,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1713314907000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7238,
              "type": 7,
              "linkobject": "devicestate.设备no2",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891505000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "数据采集通道`设备测试通道` 设备no2 通讯中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "设备测试1",
              "unitId": "7fbf4d3b83174aa9b74a27ef582e1b9a",
              "deviceNo": 23,
              "deviceName": "设备no2"
            },
            {
              "no": 7235,
              "type": 7,
              "linkobject": "配电房有源滤波",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891500000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`配电房有源滤波`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "配电房",
              "unitId": "FC0203DA14C845A4BA18E7F53DD5A4FC",
              "deviceNo": 30,
              "deviceName": "有源滤波器"
            },
            {
              "no": 7234,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891499000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7231,
              "type": 7,
              "linkobject": "上海晔燃",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891499000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`上海晔燃`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "上海科技",
              "unitId": "6C8D9A0A1B894AA3A585B57E928FD923",
              "deviceNo": 26,
              "deviceName": "晔燃水表"
            },
            {
              "no": 7230,
              "type": 7,
              "linkobject": "英派尔",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712891499000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`英派尔`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 19,
              "deviceName": "英派尔预付费表"
            },
            {
              "no": 7229,
              "type": 7,
              "linkobject": "devicestate.设备no2",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824156000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "数据采集通道`设备测试通道` 设备no2 通讯中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "设备测试1",
              "unitId": "7fbf4d3b83174aa9b74a27ef582e1b9a",
              "deviceNo": 23,
              "deviceName": "设备no2"
            },
            {
              "no": 7226,
              "type": 7,
              "linkobject": "上海晔燃",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824151000,
              "eventstate": 0,
              "eventlevel": 2,
              "description": "通道`上海晔燃`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "上海科技",
              "unitId": "6C8D9A0A1B894AA3A585B57E928FD923",
              "deviceNo": 26,
              "deviceName": "晔燃水表"
            },
            {
              "no": 7224,
              "type": 7,
              "linkobject": "配电房有源滤波",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824151000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`配电房有源滤波`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "配电房",
              "unitId": "FC0203DA14C845A4BA18E7F53DD5A4FC",
              "deviceNo": 30,
              "deviceName": "有源滤波器"
            },
            {
              "no": 7222,
              "type": 7,
              "linkobject": "英派尔",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824151000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`英派尔`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 19,
              "deviceName": "英派尔预付费表"
            },
            {
              "no": 7221,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712824145000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7220,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712739597000,
              "eventstate": 0,
              "eventlevel": 0,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7218,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712728134000,
              "confirmuser": "1",
              "time": 1712623751000,
              "eventstate": 3,
              "eventlevel": 0,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7217,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712729464000,
              "confirmuser": "1",
              "time": 1712622155000,
              "eventstate": 3,
              "eventlevel": 0,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7215,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712728137000,
              "confirmuser": "1",
              "time": 1712484119000,
              "eventstate": 3,
              "eventlevel": 1,
              "description": "通道`设备通道`中断",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            },
            {
              "no": 7214,
              "type": 7,
              "linkobject": "设备通道",
              "confirmtime": 1712728230000,
              "confirmuser": "1",
              "time": 1712319467000,
              "eventstate": 3,
              "eventlevel": 1,
              "description": "通道`设备通道`恢复",
              "linkdevice": -858993460,
              "typeName": "通信信息",
              "limitedColor": null,
              "unitName": "中山市电气",
              "unitId": "0A200022945047D7A5E538EDFC40FA2A",
              "deviceNo": 13,
              "deviceName": "水元一4011电线1211"
            }
          ]
        };
        this.eventList = respon.data;

        var xiaoxiArr = this.eventList.filter(item => item.eventlevel == 0)
        var yujingArr = this.eventList.filter(item => item.eventlevel == 1)
        var gaojingArr = this.eventList.filter(item => item.eventlevel == 2)

        this.xiaoxiNum = xiaoxiArr.length
        this.yujingNum = yujingArr.length
        this.gaojingNum = gaojingArr.length

        this.option.series[0].data[0].value = this.xiaoxiNum
        this.option.series[0].data[1].value = this.yujingNum
        this.option.series[0].data[2].value = this.gaojingNum

        this.init()



      }
    },
    filters: {
      // 转换时间戳
      "date_format": function (value) { //value就是插值的数据
        if (!value) {
          return ""
        }
        let date = new Date(value);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        let strDate = M + D + h + m;
        return strDate
      },
    }
  }
</script>

<style scoped lang="scss">
  .distributing {
    width: 100%;
    height: 100%;
    padding: 0px !important;

    .con {
      width: 100%;
      height: 100%;
      background: url(../../assets/puKanBan/bg.png) no-repeat;
      background-size: 100% 100%;
      overflow: hidden;

      .title-top {
        width: 100%;
        position: relative;

        .ti-topimg {
          width: 100%;

          img {
            width: 100%;
          }
        }

        .ti-time {
          position: absolute;
          left: 24px;
          top: 50%;

          span {
            color: #88C6FF;
            font-weight: bold;
            font-size: 0.16rem;
          }
        }

        .ti-fangda {
          position: absolute;
          top: 50%;
          right: 24px;
          //  img {
          //   width: 30px;
          //   height: 30px;
          //  }
        }


      }

      .con-body {
        width: 100%;
        height: 86%;
        margin-top: 30px;
        display: flex;
        padding: 0px 20px;
        box-sizing: border-box;

        .body-left {
          width: 25%;
          height: 100%;

          .tempercon-top {
            width: 100%;
            height: calc(25% - 8px);
            display: flex;
            align-items: center;

            div {
              width: 25%;
              height: 100%;
              color: #fff;
              box-sizing: border-box;
              font-size: 14px;
              font-weight: bold;
              display: flex;
              align-items: center;
              justify-content: center;
            }



          }

          .templine {
            width: 100%;
            height: 1px;
            background-color: #102C4B;
            margin-top: 8px;
          }

          .tempercon-item {
            width: 100%;
            height: calc(25% - 8px);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8px;

            div {
              width: 25%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .itname {
              color: #fff;
            }

            .wendu {
              color: #FF912C;
            }

            .shidu {
              color: #2CE6FF;
            }

            .state {
              .bigbox {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                border: 1px solid #C00000;

                .box {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background-color: #C00000;

                }
              }

              &.greenjing {
                .bigbox {
                  border-color: #00C07B;

                  .box {
                    background-color: #00C07B;
                  }
                }
              }
            }
          }

          .texu {
            background-color: #071727;
          }


          .roominformation {
            width: 100%;
            height: 28%;
            margin-bottom: 8px;

            .smcon {
              width: 100%;
              height: 84%;
              padding: 0px 13px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: space-evenly;

              .jifang-item {
                width: 25%;
                height: 60%;
                text-align: center;

                img {
                  width: 40%;
                  height: 39%;
                  margin-top: 8px;
                }

                .numall {
                  font-size: 18px;
                  font-weight: bold;

                  span {
                    font-size: 16px;
                    font-weight: bold;

                  }
                }

                .text {
                  margin-top: 3px;
                  font-size: 12px;
                }
              }

              .total1 {
                background: url(../../assets/puKanBan/border1.png) no-repeat;
                background-size: 100% 100%;

                .numall {
                  color: #67B6FF;

                }

                .text {
                  color: #67B6FF;
                }
              }

              .total2 {
                background: url(../../assets/puKanBan/border2.png) no-repeat;
                background-size: 100% 100%;

                .numall {
                  color: #2CE6FF;

                }

                .text {
                  color: #2CE6FF;
                }
              }

              .total3 {
                background: url(../../assets/puKanBan/border3.png) no-repeat;
                background-size: 100% 100%;

                .numall {
                  color: #FF912C;

                }

                .text {
                  color: #FF912C;
                }
              }


            }

          }

          .temperature {
            width: 100%;
            height: 29%;
            margin-bottom: 8px;

            .tempercon {
              width: 100%;
              height: 83%;
              padding: 15px;
              box-sizing: border-box;
            }

          }

          .infrared {
            width: 100%;
            height: calc(21% - 8px);
            margin-bottom: 8px;

            .infrared-con {
              width: 100%;
              height: 78%;
              padding: 25px 15px;
              box-sizing: border-box;

              .tempercon-top {
                height: calc(50% - 4px);
              }

              .tempercon-item {
                height: calc(50% - 4px);
              }

            }
          }

          .accesscontrol {
            width: 100%;
            height: calc(21% - 9px);

            .accesscontrol-con {
              width: 100%;
              height: 78%;
              padding: 25px 15px;
              box-sizing: border-box;

              .tempercon-top {
                height: calc(50% - 4px);
              }

              .tempercon-item {
                height: calc(50% - 4px);
              }

            }
          }
        }

        .body-milll {
          width: calc(50% - 24px);
          height: 100%;
          margin: 0px 12px;
          background: url(../../assets/puKanBan/Rectangle.png) no-repeat;
          background-size: 100% 100%;
          position: relative;

          .mytext {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 105px;
            height: 50px;
            padding: 8px;
            box-sizing: border-box;

            .tetx-item {
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .num1 {
                color: #FF912C;
              }
            }
          }

          .item1 {
            position: absolute;
            top: 18%;
            left: 10%;
            width: 157px;
            height: 104px;

            img {
              width: 100%;
              height: 100%;
            }

          }

          .item2 {
            width: 207px;
            height: 74px;
            position: absolute;
            top: 73%;
            left: 34%;

            img {
              width: 100%;
              height: 100%;
            }

            .mytext {
              top: 20px;
            }
          }

          .item3 {
            width: 184px;
            height: 70px;
            position: absolute;
            top: 6%;
            left: 70%;

            img {
              width: 100%;
              height: 100%;
            }

          }

          .item4 {
            position: absolute;
            top: 7%;
            left: 40%;
            width: 157px;
            height: 104px;

            img {
              width: 100%;
              height: 100%;
            }

            .num2 {
              color: green;
            }

            .num3 {
              color: red;
            }
          }

          .item5 {
            width: 207px;
            height: 74px;
            position: absolute;
            top: 64%;
            left: 45%;

            img {
              width: 100%;
              height: 100%;
            }

            .mytext {
              top: 20px;
            }

            .num2 {
              color: green;
            }

            .num3 {
              color: red;
            }
          }
        }

        .body-right {
          width: 25%;
          height: 100%;

          .eventtype {
            width: 100%;
            height: 34%;
            margin-bottom: 8px;

            .eventtype-con {
              width: 100%;
              height: 83%;
              padding: 30px 20px;
              box-sizing: border-box;
              display: flex;

              .type-item {
                width: 50%;
                height: 100%;
                position: relative;

                .allnum {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  text-align: center;
                  color: #fff;

                  span {
                    font-size: 16px;
                    font-weight: bold;
                  }
                }

              }

              .type-items {
                width: 50%;
                height: 100%;
              }

              .juti {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                .titi {
                  width: 100%;
                  padding: 0px 20px;
                  box-sizing: border-box;
                }

                .juti-item {
                  width: 100%;
                  height: 25%;
                  display: flex;
                  align-items: center;
                  color: #fff;
                  justify-content: space-between;

                  &.active {
                    margin: 20px 0px;
                  }

                  .left {
                    display: flex;
                    align-items: center;
                  }

                  .leftcolor {
                    width: 11px;
                    height: 11px;

                    border-radius: 1px;
                    margin-right: 8px;
                  }

                  .colorxiaoxi {
                    background-color: #2ce6ff;
                  }

                  .coloryujing {
                    background-color: #ff912c;
                  }

                  .colorgaojing {
                    background-color: #e76238;
                  }
                }
              }

            }
          }

          .eventlist {
            width: 100%;
            height: calc(66% - 8px);

            .eventlist-con {
              width: 100%;
              height: 90%;
              padding: 4px 12px 15px 12px;
              box-sizing: border-box;

              .list-item {
                width: 100%;
                height: 28px;
                margin-top: 11px;
                display: flex;
                align-items: center;

                .lefttype {
                  width: 36px;
                  height: 20px;
                  border: 1px solid #FF912C;
                  border-radius: 4px;
                  text-align: center;
                  line-height: 20px;
                  color: #FF912C;
                  font-size: 12px;
                }

                .xiaoxitype {
                  border-color: #2CE6FF;
                  color: #2CE6FF;
                }

                .yujingtype {
                  border-color: #FF912C;
                  color: #FF912C;
                }

                .jingtype {
                  border-color: #E76238;
                  color: #E76238;
                }

                .milltext {
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin: 0px 5px;
                  color: #fff;
                  font-size: 14px;
                }

                .righttimer {
                  width: 75px;
                  height: 100%;
                  color: #fff;
                  line-height: 28px;
                }

              }
            }
          }
        }

      }

      .small-title {
        position: relative;

        .smbgimg {
          width: 100%;
        }

        img {
          vertical-align: bottom;
        }

        span {
          position: absolute;
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          top: 49%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .rowleft {
          position: absolute;
          left: 30%;
          top: 50%;
          transform: translateY(-50%);
        }

        .rowright {
          position: absolute;
          right: 30%;
          top: 50%;
          transform: translateY(-50%) rotateY(180deg);
        }
      }

      .smbg {
        background: url(../../assets/puKanBan/smbg.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
</style>